
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ResellerPlanDetails } from '@/hooks/license/resellerPlans/types';
import PlanBasicInfo from '@/components/superadmin/resellerPlan/PlanBasicInfo';
import PlanPricing from '@/components/superadmin/resellerPlan/PlanPricing';
import PlanFeatures from '@/components/superadmin/resellerPlan/PlanFeatures';
import PlanLimits from '@/components/superadmin/resellerPlan/PlanLimits';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Save } from 'lucide-react';

interface EditPlanFormProps {
  plan: ResellerPlanDetails;
  plans: ResellerPlanDetails[];
  currentPlanIndex: number;
  onSelectPlan: (index: number) => void;
  onUpdatePlan: (field: keyof ResellerPlanDetails, value: any) => void;
  onAddFeature: () => void;
  onSavePlan: () => Promise<boolean>;
  isSaving: boolean;
}

const EditPlanForm: React.FC<EditPlanFormProps> = ({
  plan,
  plans,
  currentPlanIndex,
  onSelectPlan,
  onUpdatePlan,
  onAddFeature,
  onSavePlan,
  isSaving
}) => {
  const handleSave = async () => {
    await onSavePlan();
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <Select 
              value={currentPlanIndex.toString()} 
              onValueChange={(value) => onSelectPlan(parseInt(value))}
            >
              <SelectTrigger className="w-[240px]">
                <SelectValue placeholder="Select plan" />
              </SelectTrigger>
              <SelectContent>
                {plans.map((p, index) => (
                  <SelectItem key={index} value={index.toString()}>
                    {p.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button 
            variant="default"
            onClick={handleSave}
            disabled={isSaving}
            className="flex items-center"
          >
            <Save className="mr-2 h-4 w-4" />
            {isSaving ? 'Saving...' : 'Save Plan'}
          </Button>
        </div>

        <Tabs defaultValue="basic">
          <TabsList className="mb-4">
            <TabsTrigger value="basic">Basic Info</TabsTrigger>
            <TabsTrigger value="pricing">Pricing</TabsTrigger>
            <TabsTrigger value="features">Features</TabsTrigger>
            <TabsTrigger value="limits">Limits</TabsTrigger>
          </TabsList>
          
          <TabsContent value="basic">
            <PlanBasicInfo plan={plan} onUpdatePlan={onUpdatePlan} />
          </TabsContent>
          
          <TabsContent value="pricing">
            <PlanPricing plan={plan} onUpdatePlan={onUpdatePlan} />
          </TabsContent>
          
          <TabsContent value="features">
            <PlanFeatures plan={plan} onUpdatePlan={onUpdatePlan} />
          </TabsContent>
          
          <TabsContent value="limits">
            <PlanLimits plan={plan} onUpdatePlan={onUpdatePlan} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default EditPlanForm;
